// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentAlternateCardId {
    static getAttributeTypeMap() {
        return EnrollmentAlternateCardId.attributeTypeMap;
    }
}
EnrollmentAlternateCardId.discriminator = undefined;
EnrollmentAlternateCardId.additionalProperties = false;
EnrollmentAlternateCardId.attributeTypeMap = [
    {
        "name": "alternateCardNumber",
        "baseName": "alternateCardNumber",
        "type": "string"
    },
    {
        "name": "cardAlternateIdType",
        "baseName": "cardAlternateIdType",
        "type": "AlternateCardType"
    },
];
//# sourceMappingURL=enrollmentAlternateCardId.js.map